import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "../../styles/Fonts.css";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaTiktok,
  FaChevronDown,
} from "react-icons/fa";
import { TfiLocationPin } from "react-icons/tfi";
import SecondNavBar from "./SecondNavBar";
import { menuList } from "../../data/menuList/MenuData";
import { SiTimescale } from "react-icons/si";

import IChName from '../../assets/images/IchName/logoICH.svg'

const clickScroller = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const Navbar: React.FC = () => {
  const menuRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  return (
    <>
      <div className="xl:block hidden">
        <div className="flex-col bg-white shadow-md main-navbar z-99" ref={menuRef}>
          {/* Top info bar */}
          <div className="bg-green-500 p-1.5"></div>
          <div className="p-2">
            <div className="flex flex-col gap-2 px-24">
              {/* Contact info and social media */}
              <div className="w-full">
                <div className="flex flex-row gap-2 items-center">
                  <div className="w-6/12 flex flex-row gap-2 items-center">
                    <TfiLocationPin className="text-green-600 text-md" />
                    <p className="text-sm text-gray-800 Blinker-Regular">
                      No.228/1, Asiri Mawatha, Kandy Road, Yakkala, Gampaha, Sri
                      Lanka.
                    </p>
                  </div>

                  <div className="w-6/12 flex flex-row gap-2 items-center">
                    <SiTimescale className="text-green-600 text-md" />
                    <p className="text-sm text-gray-800 Blinker-Regular">
                      24/7 Ayurveda Care
                    </p>
                  </div>

                  <div className="w-2/12 flex flex-row justify-between">
                    {[
                      {
                        icon: <FaFacebookF />,
                        url: "https://www.facebook.com/CeylonHospital",
                      },
                      {
                        icon: <FaYoutube />,
                        url: "https://www.youtube.com/@ceylonhospital",
                      },
                      {
                        icon: <FaInstagram />,
                        url: "https://www.instagram.com/ceylonhospital",
                      },
                      {
                        icon: <FaLinkedinIn />,
                        url: "https://www.linkedin.com/company/ceylon-hospital",
                      },
                      {
                        icon: <FaTiktok />,
                        url: "https://www.tiktok.com/@ceylonhospital",
                      },
                    ].map((social, index) => (
                      <button
                        key={index}
                        onClick={() => window.open(social.url, "_blank")}
                        className="text-sm text-gray-600 hover:bg-green-400 hover:text-white p-1.5 rounded-full border hover:border-green-600 transition-colors duration-500"
                        aria-label={`Share on ${social.icon}`}
                      >
                        <span aria-hidden="true">{social.icon}</span>
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* Main navigation */}
              <div className="w-full">
                <div className="w-full">
                  <div className="flex flex-row gap-4 items-center w-full bg-gray-50 px-6 py-2 rounded-full border border-gray-200 shadow-sm">
                    {/* Logo Section */}
                    <div className="w-3/12 min-w-[200px]">

                      <img src={IChName} alt="Ceylon Hospital" width={200} height={100} />


                      {/* <p className="font-bold text-3xl text-green-700 Blinker-Bold py-2 hover:text-green-800 transition-colors">
                        Ceylon Hospital
                      </p> */}
                    </div>

                    <div className="w-7/12">
                      <nav className="flex flex-row gap-4 justify-center">
                        {menuList.map((item) => {
                          // Check if current path matches main nav item or any of its submenu items
                          const isActive = location.pathname === item.url ||
                            (item.submenu && item.submenu.some(subItem =>
                              location.pathname === subItem.url
                            ));

                          return (
                            <div key={item.id} className="relative group">
                              <div className="flex items-center">
                                <Link
                                  to={item.url || "#"}
                                  className={`group px-3 py-2 font-medium transition-all duration-200 Blinker-SemiBold ${isActive
                                    ? "text-white bg-green-800 rounded-lg"
                                    : "text-gray-900 hover:text-green-600"
                                    }`}
                                  onClick={clickScroller}
                                  aria-current={isActive ? "page" : undefined}
                                  aria-haspopup={item.submenu ? "true" : undefined}
                                >
                                  <div className="flex flex-row items-center">
                                    {item.name}
                                    {item.submenu && (
                                      <span
                                        className={`ml-1 transition-colors duration-200 ${isActive
                                          ? "text-white"
                                          : "text-gray-700 group-hover:text-green-600"
                                          }`}
                                      >

                                        <FaChevronDown size={12} />
                                      </span>
                                    )}
                                  </div>
                                </Link>
                              </div>

                              {item.submenu && (
                                <div className="absolute left-1/2 transform -translate-x-1/2 mt-1 w-56 bg-white rounded-lg shadow-lg py-2 z-50 border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible group-hover:mt-3 transition-all duration-200">
                                  {item.submenu.map((subItem) => (
                                    <Link
                                      key={subItem.id}
                                      to={subItem.url}
                                      className={`block px-4 py-2 text-sm Blinker-Regular ${location.pathname === subItem.url
                                        ? "bg-green-100 text-green-700 font-medium"
                                        : "text-gray-700 hover:bg-green-50 hover:text-green-700"
                                        } transition-colors`}
                                      onClick={clickScroller}
                                    >
                                      {subItem.name}
                                    </Link>
                                  ))}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </nav>
                    </div>





                    {/* CTA Button */}
                    <div className="w-2/12 flex justify-end">
                      <Link to="/book-appointment">
                        <button className="bg-green-800 Blinker-SemiBold hover:bg-green-900 text-white text-sm py-2.5 px-6 rounded-lg focus:ring-2 focus:ring-green-600 focus:ring-offset-2 transition-colors">
                          Book Appointment
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <SecondNavBar />
    </>
  );
};

export default Navbar;
